class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Store references to elements we'll need
    this.filters = document.getElementById('main-collection-filters');
    this.gridAnchor = document.querySelector('.grid-anchor');
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${FacetFiltersForm.getSectionId()}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    // Update the next URL after the product grid is rendered
    updateNextUrlAfterFilter();
  }

  static getSectionId() {
    return window.innerWidth <= 1024 
      ? 'main-collection-product-grid-18-static'
      : 'main-collection-product-grid';
  }
  

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        window.PopoverManager.init();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const elementToReplace = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      if (elementToReplace) {
        elementToReplace.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-mobile-inner', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  loadTemplateBasedOnWidth() {
    const isSmallScreen = window.innerWidth <= 1024;
    const isFilterColumnsActive = this.gridAnchor.classList.contains('filter-columns');
    const sectionId = isSmallScreen || !isFilterColumnsActive ? 'main-collection-product-grid-18-static' : 'main-collection-product-grid';
    let url = `${window.location.pathname}?section_id=${sectionId}&${FacetFiltersForm.searchParamsPrev}`;
console.log(url);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const new_html = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .getElementById('ProductGridContainer').innerHTML;
        document.getElementById('ProductGridContainer').innerHTML = new_html;
        this.updateDataIdAttributes();
        updateNextUrlAfterFilter();
       // yotpo.initWidgets(); //callback for legacy Yotpo widgets
        yotpoWidgetsContainer.initWidgets(); //callback for newer yotpo widgets
        window.initializeModals?.();
        // Re-initialize Klaviyo Back In Stock
        initKlaviyo();
        window.PopoverManager.init();
        window.reinitializeVariantPopovers();
      });
  }

  updateDataIdAttributes() {
    const isSmallScreen = window.innerWidth <= 1024;
    const newId = 'main-collection-product-grid-18-static';
    const elementsToUpdate = document.querySelectorAll('[data-id="main-collection-product-grid"]');

    elementsToUpdate.forEach((element) => {
      if (isSmallScreen) {
        element.setAttribute('data-id', newId);
      } else {
        element.setAttribute('data-id', 'main-collection-product-grid');
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm')  {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
    this.loadTemplateBasedOnWidth();
  }

  onActiveFilterClick(event) {
   // console.log('Remove filter click');
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    console.log('FacetRemove');
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// Customizations

function updateNextUrlAfterFilter() {
  setTimeout(() => {
    const productGrid = document.getElementById('product-grid');
    const nextUrl = productGrid.getAttribute('data-next-url');
    const loadMoreButton = document.getElementById('load-more');

    if (!nextUrl) {
      loadMoreButton.style.display = 'none';
    } else {
      loadMoreButton.style.display = 'block';
    }
  }, 1000);
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.collection-no-filter')) {
    return;
  }
 
  const facetFiltersForm = document.querySelector('facet-filters-form');
  if (!facetFiltersForm) return;

  const toggleButton = document.getElementById('toggle-filters-button');
  const filters = document.getElementById('main-collection-filters');
  const toggleText = toggleButton.querySelector('.toggle-text');
  const gridAnchor = document.querySelector('.grid-anchor');
  const loadMoreButton = document.getElementById('load-more');

  function toggleFilters() {
    const isHidden = filters.style.display === 'none';

    if (isHidden) {
      filters.style.display = 'block';
      toggleText.textContent = 'Hide Filters';
      toggleButton.setAttribute('aria-expanded', 'true');
      gridAnchor.classList.add('filter-columns');
    } else {
      filters.style.display = 'none';
      toggleText.textContent = 'Show Filters';
      toggleButton.setAttribute('aria-expanded', 'false');
      gridAnchor.classList.remove('filter-columns');
    }
    
    facetFiltersForm.loadTemplateBasedOnWidth();
  }





  function checkNextUrlOnPageLoad() {
    const productGrid = document.getElementById('product-grid');
    const nextUrl = productGrid.getAttribute('data-next-url');

    if (!nextUrl) {
      loadMoreButton.style.display = 'none';
    } else {
      loadMoreButton.style.display = 'block';
    }
  }

  toggleButton.addEventListener('click', toggleFilters);
  toggleButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleFilters();
    }
  });

  function updateNextUrl() {
    const updatedProductGrid = document.getElementById('product-grid');
    const isFiltersHidden = document.getElementById('main-collection-filters').style.display === 'none';
    const sectionId = window.innerWidth <= 1024 ? 'main-collection-product-grid-18-static' : (isFiltersHidden ? 'main-collection-product-grid-18-static' : 'main-collection-product-grid');
    const baseNextUrl = updatedProductGrid ? updatedProductGrid.getAttribute('data-next-url') : null;

    if (baseNextUrl) {
      // Handle relative URLs by prepending the current origin
      const url = new URL(baseNextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      return url.toString();
    }
    return null;
  }

  loadMoreButton.addEventListener('click', function(event) {
    const nextUrl = updateNextUrl();
    console.log('Loading Content from:', nextUrl);

    if (!nextUrl) {
      loadMoreButton.style.display = 'none';
      return;
    }

    fetch(nextUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const newProductItems = doc.querySelectorAll('#product-grid > *');
        const currentProductGrid = document.getElementById('product-grid');

        newProductItems.forEach(item => currentProductGrid.appendChild(item));

        const newNextUrl = doc.getElementById('product-grid').getAttribute('data-next-url');
        console.log({ newNextUrl });
        currentProductGrid.setAttribute('data-next-url', newNextUrl);
        window.initializeModals?.();
        if (!newNextUrl) {
          loadMoreButton.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
      });
  });

  // Initial check on page load
  checkNextUrlOnPageLoad();
  if (window.innerWidth < 1024) {
  facetFiltersForm.loadTemplateBasedOnWidth();
  }

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

window.addEventListener('resize', debounce(() => {
  facetFiltersForm.loadTemplateBasedOnWidth();
}, 250));
});